"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDiversityKey = void 0;
const useSelector_1 = require("./useSelector");
function useDiversityKey() {
    return (0, useSelector_1.useSelector)(state => state === null || state === void 0 ? void 0 : state.diversityKey);
}
exports.useDiversityKey = useDiversityKey;
